import { rgba } from 'polished';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styled from 'styled-components';
import {
    DEPRECATED,
    slate40,
    white,
} from '@zocdoc-mezzanine/foundations-colors';
import ErrorMessage from '@zocdoc-frontend-common/components-errormessage';
import { linkStyle } from '@zocdoc-frontend-common/components-link';
import { FontFamily } from '@zocdoc-frontend-common/styles-typography';

export class AddPhoneBox extends Component {
    static propTypes = {
        hasError: PropTypes.bool,
        onClick: PropTypes.func,
    };

    maybeRenderInvalidMessage(hasError) {
        if (hasError) {
            return (
                <ErrorMessage data-test="add-phone-error">
                    Please add your phone number.
                </ErrorMessage>
            );
        }
    }

    render() {
        const { hasError, onClick } = this.props;

        return (
            <Container>
                <AddPhoneNumber
                    data-test="add-phone-number"
                    hasError={hasError}
                    onClick={onClick}
                    role="button"
                    tabIndex="0"
                >
                    <LooksLikeALink data-test="add-phone-number-link">
                        Add phone number
                    </LooksLikeALink>
                </AddPhoneNumber>
                {this.maybeRenderInvalidMessage(hasError)}
            </Container>
        );
    }
}

const Container = styled.div`
    position: relative;
`;

const AddPhoneNumber = styled.div`
    border: solid 1px
        ${p => (p.hasError ? DEPRECATED.tertiaryCoral : rgba(slate40, 0.5))};
    background-color: ${white};
    box-sizing: content-box;
    height: 16px;
    padding: 16px;
    cursor: pointer;
`;

const LooksLikeALink = styled.div`
    ${linkStyle};
    font: 15px/18px ${FontFamily.SharpSansSemibold};
    padding-top: 1px;
    padding-bottom: 0;
    position: absolute;
    float: right;
    top: 16px;
    left: 12px;
`;
